var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('b-spinner',{style:({ width: '80px', height: '80px' }),attrs:{"variant":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }